import {
  CurrencyDollarIcon,
  FireIcon,
  UserGroupIcon,
} from "@heroicons/react/24/solid";

const features = [
  {
    name: "Earn Revenue",
    description:
      "Offer flexible opportunities for your viewers to interact with your platform.",
    icon: CurrencyDollarIcon,
  },
  {
    name: "Prosper Viewership",
    description:
      "Develop intimate relationships between yourself and your audience.",
    icon: FireIcon,
  },
  {
    name: "Manage Events",
    description:
      "Distribute event details to fans and communicate with buyers.",
    icon: UserGroupIcon,
  },
];

function Bar() {
  return (
    <div className="py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="sm:text-center">
          <h2 className="text-lg font-semibold leading-8 text-primary-600">
            Features
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
            A better way to connect with Audiences
          </p>
        </div>

        <div className="mt-20 max-w-lg sm:mx-auto md:max-w-none">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {features.map((feature) => (
              <div
                key={feature.name}
                className="group bg-slate-50 rounded-2xl p-8 text-center shadow-lg hover:scale-105 hover:shadow-xl transition duration-200"
              >
                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-primary-100 mx-auto">
                  <feature.icon
                    className="h-8 w-8 text-primary-600"
                    aria-hidden="true"
                  />
                </div>
                <h3 className="mt-6 text-lg font-semibold text-gray-900">
                  {feature.name}
                </h3>
                <p className="mt-4 text-base text-gray-600">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Bar;
